import { Field, Form, Formik, ErrorMessage } from "formik";
import React, { useEffect, useState } from "react";
import { Button, Row } from "react-bootstrap";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import * as Yup from "yup";
import { useSelector, useDispatch } from "react-redux";
import {
  getAllStateByRegionId,
  getAllStatesbyRegionIdforCon,
  getDiscomByStateId,
  getDiscomByStateIdforCon,
  registartionRequest,
} from "../../../store/Registartion/actions";
import moment from "moment";
import "./registration.css";
import plantDetailsService from "../../../components/Services/plantDetails.service";
import { toast } from "react-toastify";
import { toastProperties } from "../../../commons/Toast/Toaster";
import { getCompanyList } from "../../../store/Login/actions";

const PlantDetails = ({
  companyDetails,
  handleSecDetails,
  secDetails,
  handleAddRoleClose,
  getAllCompanyAdminUsers,
}) => {
  const dispatch = useDispatch();
  const token = useSelector((state) => state?.sessionState?.token);
  const controlAreaTypes = useSelector(
    (state) => state?.registrationReducer?.controlAreaTypes || []
  );
  const discomTypes = useSelector(
    (state) => state?.registrationReducer?.discomTypes || []
  );
  const regionTypes = useSelector(
    (state) => state?.registrationReducer?.regionTypes || []
  );
  const specificationTypes = useSelector(
    (state) => state?.registrationReducer?.specificationTypes || []
  );
  const energyTypes = useSelector(
    (state) => state?.registrationReducer?.energyTypes || []
  );
  const allPointDrawl = useSelector(
    (state) => state.registrationReducer?.allPointDrawl || []
  );
  const stateOptions = useSelector(
    (state) => state?.registrationReducer?.stateOptions || []
  );
  const discomOptions = useSelector(
    (state) => state?.registrationReducer?.discomOptions || []
  );
  const stateOptionsCon = useSelector(
    (state) => state?.registrationReducer?.stateOptionsCon || []
  );
  const discomOptionsCon = useSelector(
    (state) => state?.registrationReducer?.discomOptionsCon || []
  );

  const searchParams = new URLSearchParams(document.location.search);
  let tab = searchParams.get("tab");
  const currentRoute = window.location.pathname;

  const initialValues = {
    isCommissioned: "",
    commissionedAt: "",
    generationType: "",
    energyTypeId: "",
    plantSpecId: tab == 4 ? 1 : "",
    maxInjCap: "",
    projectId: "",
    installedCap: "",
    isSubsidyRecvd: "",
    subsidyType: "",
    isAbtExist: "",
    poiId: "",
    poiLocation: "",
    regionId: "",
    stateUtId: "",
    isDiscomEmb: "",
    discomId: "",
    discomVoltageId: "",
    controlAreaId: "",
    filteredVoltageLevels: "",
    //consumer Details
    maxCapDrawl: "",
    podId: "",
    specId: tab == 4 ? 6 : "",
    conDiscomId: "",
    conFilteredVoltageLevels: "",
    conDiscomVoltageId: "",
    discomRegionId: "",
    discomStateUtId: "",
  };

  const validationSchema = Yup.object().shape({
    // isCommissioned: Yup.string().required("Commissioned Required"),
    // generationType:
    //   tab == 4
    //     ? Yup.string().notRequired()
    //     : Yup.string().required("Generating Type Required"),
    // commissionedAt: Yup.string().when("isCommissioned", (isCommissioned) => {
    //   if (isCommissioned == 1) {
    //     return Yup.string().required("Date Required");
    //   } else return Yup.string().notRequired("");
    // }),
    // energyTypeId:
    //   tab == 4
    //     ? Yup.string().notRequired()
    //     : Yup.string().required("Energy Type Required"),
    // plantSpecId:
    //   tab == 4
    //     ? Yup.string().notRequired()
    //     : Yup.string().required("Plant Specification Required"),
    // maxInjCap: Yup.number()
    // .test(
    //   "valueRange",
    //   "Value must be between 0 and 10,000 with 3 decimal places",
    //   (value) => {
    //     if (value === undefined || value === null) {
    //       return true;
    //     }
    //     const decimal = String(value).split(".")[1];
    //     return (
    //       value >= 0 && value <= 10000 && (decimal?.length <= 3 || !decimal)
    //     );
    //   }
    // )
    // .required("Required Field"),
    installedCap:
      tab == 4
        ? Yup.number()
            .test(
              "valueRange",
              "Value must be between 0 and 10,000 with 3 decimal places",
              (value) => {
                if (value === undefined || value === null) {
                  return true;
                }
                const decimal = String(value).split(".")[1];
                return (
                  value >= 0 &&
                  value <= 10000 &&
                  (decimal?.length <= 3 || !decimal)
                );
              }
            )
            .notRequired()
        : Yup.number()
            .test(
              "valueRange",
              "Value must be between 0 and 10,000 with 3 decimal places",
              (value) => {
                if (value === undefined || value === null) {
                  return true;
                }
                const decimal = String(value).split(".")[1];
                return (
                  value >= 0 &&
                  value <= 10000 &&
                  (decimal?.length <= 3 || !decimal)
                );
              }
            )
            .required("Required Field"),
    // isSubsidyRecvd: Yup.string().required("Subsidy Required"),
    // isAbtExist: Yup.string().required("ABT Metering Required"),
    // controlAreaId: Yup.string().required("Control Area Required"),
    // poiId: Yup.string().required("Point of Injection Required"),
    // poiLocation: Yup.string()
    //   .matches(/^[a-zA-Z0-9\s]+$/, "Only Alpha Numerics are allowed")
    //   .required("POI Location Required"),
    // regionId:
    //   tab == 4
    //     ? Yup.string().notRequired()
    //     : Yup.string().required("Region Required"),
    // stateUtId:
    //   tab == 4
    //     ? Yup.string().notRequired()
    //     : Yup.string().required("State Required"),
    // discomId:
    //   tab == 4
    //     ? Yup.string().notRequired()
    //     : Yup.string().required("Discom Required"),
    // discomVoltageId:
    //   tab == 4
    //     ? Yup.string().notRequired()
    //     : Yup.string().required("Discom voltage Required"),
    //Consumer details
    // discomRegionId:
    //   tab == 3
    //     ? Yup.string().required("Region Required")
    //     : Yup.string().notRequired(),
    // discomStateUtId:
    //   tab == 3
    //     ? Yup.string().required("State Required")
    //     : Yup.string().notRequired(),
    // conDiscomId:
    //   tab == 3
    //     ? Yup.string().required("Discom Required")
    //     : Yup.string().notRequired(),
    // conDiscomVoltageId:
    //   tab == 3
    //     ? Yup.string().required("Discom voltage Required")
    //     : Yup.string().notRequired(),
    maxCapDrawl:
      tab == 3
        ? Yup.number()
            .test(
              "valueRange",
              "Value must be between 0 and 10,000 with 3 decimal places",
              (value) => {
                if (value === undefined || value === null) {
                  return true;
                }
                const decimal = String(value).split(".")[1];
                return (
                  value >= 0 &&
                  value <= 10000 &&
                  (decimal?.length <= 3 || !decimal)
                );
              }
            )
            .required("Required Field")
        : Yup.number()
            .test(
              "valueRange",
              "Value must be between 0 and 10,000 with 3 decimal places",
              (value) => {
                if (value === undefined || value === null) {
                  return true;
                }
                const decimal = String(value).split(".")[1];
                return (
                  value >= 0 &&
                  value <= 10000 &&
                  (decimal?.length <= 3 || !decimal)
                );
              }
            )
            .notRequired(),
    // projectId: Yup.string()
    //   .matches(
    //     /^[a-zA-Z0-9]+$/,
    //     "Only Alpha Numerics are allowed with No spaces"
    //   )
    //   .notRequired(),
    // subsidyType: Yup.string()
    //   .matches(/^[a-zA-Z0-9\s]+$/, "Only Alpha Numerics are allowed")
    //   .notRequired(),
  });

  const submitData = (isValid, dirty, values) => {
    if (isValid && dirty) {
      handleSecDetails(values);
    } else if (!isValid) {
      setTimeout(() => {
        handleSecDetails("");
      }, 0);
    }
  };

  const handleStateChange = (id) => {
    getDiscomByStateId(id, dispatch);
  };

  const handleStateChangeforCon = (id) => {
    getDiscomByStateIdforCon(id, dispatch);
  };

  const numberInputOnWheelPreventChange = (e) => {
    // Prevent the input value change
    e.target.blur();

    // Prevent the page/container scrolling
    e.stopPropagation();

    // Refocus immediately, on the next tick (after the current function is done)
    setTimeout(() => {
      e.target.focus();
    }, 0);
  };
  const createGenerator = (reqBody) => {
    plantDetailsService
      .createGenerator(reqBody)
      .then((response) => {
        if (response?.data?.code === 200) {
          getCompanyList()(dispatch);
          getAllCompanyAdminUsers && getAllCompanyAdminUsers();
          handleAddRoleClose();
          toast.success(response?.data?.message, toastProperties);        }
      })
      .catch((err) => console.log("Api Call Error: ", err));
  };

  return (
    <Formik
      initialValues={secDetails || initialValues}
      validationSchema={validationSchema}
      onSubmit={(values) => {
        let reqBodyConsumer = {
          maxCapDrawl: +values.maxCapDrawl,
          podId: values.podId,
          specId: +values.specId,
          discomId: tab == 4 ? companyDetails?.conDiscomId : values.conDiscomId,
          discomVoltage: values.conDiscomVoltageId,
          stateUtId:
            tab == 4
              ? companyDetails?.discomStateUtId
              : +values.discomStateUtId,
          regionId:
            tab == 4 ? companyDetails?.discomRegionId : +values.discomRegionId,
          istsVoltage: values.istsDiscomVoltageId,
          stuVoltage: values.stuDiscomVoltageId,
        };
        let reqBodyPlant = {
          isCommissioned: values.isCommissioned === 1 ? true : false,
          commissionedAt: values.commissionedAt
            ? moment(values.commissionedAt).format("DD-MMM-YYYY")
            : values.commissionedAt,
          generationType: values.generationType,
          energyTypeId: parseInt(values.energyTypeId),
          plantSpecId: parseInt(values.plantSpecId),
          maxInjCap: parseInt(values.maxInjCap),
          projectId: values.projectId,
          installedCap: parseInt(values.installedCap),
          isSubsidyRecvd: values.isSubsidyRecvd == 1 ? true : false,
          subsidyType: values.subsidyType,
          isAbtExist: values.isAbtExist == 1 ? true : false,
          controlAreaId: parseInt(values.controlAreaId),
          poiId: parseInt(values.poiId),
          poiLocation: values.poiLocation,
          regionId:
            tab == 4
              ? companyDetails?.discomRegionId
              : parseInt(values.regionId),
          stateUtId:
            tab == 4
              ? companyDetails?.discomStateUtId
              : parseInt(values.stateUtId),
          discomId:
            tab == 4 ? companyDetails?.conDiscomId : parseInt(values.discomId),
          discomVoltage: values.discomVoltageId,
        };
        let reqData = {
          holdingCompanyId: +companyDetails?.holdingCompany,
          user: {
            userName: companyDetails?.userName,
            email: companyDetails?.email,
            password: companyDetails?.password,
            phone: String(companyDetails?.phone),
            roles:
              tab == 1
                ? ["GENERATOR"]
                : tab == 3
                ? ["GENERATOR", "CONSUMER"]
                : tab == 4
                ? ["GENERATOR", "CONSUMER", "BANKING"]
                : "",
          },
          company: {
            name: companyDetails?.name,
            displayName: companyDetails?.displayName,
            description: companyDetails?.description,
            discomId: companyDetails?.conDiscomId,
            istsVoltageLevel: companyDetails?.istsDiscomVoltageId,
            stuVoltageLevel: companyDetails?.stuDiscomVoltageId,
            // "logo": companyDetails?.logo,
            categoryId: +companyDetails?.categoryId,
            registeredAt: companyDetails?.registeredAt
              ? moment(companyDetails?.registeredAt).format("DD-MMM-YYYY")
              : companyDetails?.registeredAt,
            pan: companyDetails?.pan,
            tan: companyDetails?.tan,
            gst: companyDetails?.gst,
            documentIds: [
              companyDetails?.PAYMENT?.id,
              companyDetails?.MOA?.id,
              companyDetails?.PAN?.id,
              companyDetails?.logo !== "" ? companyDetails?.logo : undefined,
            ].filter(Boolean),
            bankAccounts: [
              {
                nameAddress: companyDetails?.nameAddress,
                accNo: companyDetails?.accNo,
                ifsc: companyDetails?.ifsc,
                operationalAt: companyDetails?.operationalAt
                  ? moment(companyDetails?.operationalAt).format("DD-MMM-YYYY")
                  : companyDetails?.operationalAt,
              },
            ],
            addresses: [
              {
                type: "OFFICE",
                address: companyDetails?.address,
                cityId: parseInt(companyDetails?.cityId),
                stateUtId: parseInt(companyDetails?.stateAndUtId),
                pin: companyDetails?.pin,
                tel: String(companyDetails?.tel),
                email: companyDetails?.officeEmail,
                fax: companyDetails?.fax ? String(companyDetails?.fax) : null,
                contactPersons: companyDetails?.contactPersons || [],
                mob: String(companyDetails?.mob),
              },
              {
                type: "CORRESPONDENCE",
                address: companyDetails?.correspondenceAddress,
                cityId: parseInt(companyDetails?.correspondenceCity),
                stateUtId: parseInt(companyDetails?.correspondenceState),
                pin: companyDetails?.correspondencePinCode,
                tel: String(companyDetails?.correspondenceTelephone),
                email: companyDetails?.correspondenceEmail,
                fax: companyDetails?.correspondenceFaxNo
                  ? String(companyDetails?.correspondenceFaxNo)
                  : null,
                contactPersons:
                  companyDetails?.correspondenceContactPerson || [],
                mob: String(companyDetails?.correspondenceMobileNo),
              },
            ],
            creditRatingId: parseInt(companyDetails?.creditRatingId),
            creditRatingYear: companyDetails?.creditRatingYear
              ? moment(companyDetails?.creditRatingYear).format("MMM-YYYY")
              : companyDetails?.creditRatingYear,
            creditRatingAgency: companyDetails?.creditRatingAgency,
            plant: reqBodyPlant,
            ...((tab == 3 || tab == 4) && { consumer: reqBodyConsumer }),
            isAcceptedByLaws: companyDetails?.confirmCheckbox,
            isAcceptedBusinessRule: companyDetails?.acceptCheckBox,
          },
        };
        tab
          ? registartionRequest(reqData, dispatch)
          : createGenerator(reqBodyPlant);
      }}
      validateOnMount={false}
      validate={(values) => {
        const errors = {};
        if (+values.maxInjCap > +values.installedCap) {
          errors.maxInjCap =
            "Injection capacity should be less than Installed capacity";
        }
        return errors;
      }}
    >
      {({
        values,
        errors,
        isValid,
        dirty,
        setFieldValue,
        setFieldTouched,
        setValues,
      }) => {
        handleSecDetails && submitData(isValid, dirty, values);
        console.log(`PlantDetails`, { values, errors });
        return (
          <Form>
            <h6>Generator Details</h6>
            <Row className="mb-4">
              <div className="col-md-6">
                <label htmlFor="isCommissioned">Plant</label>
                <div className="d-flex gap-3">
                  <div className="form-check-flex">
                    <Field
                      className="form-check-input"
                      type="radio"
                      name="isCommissioned"
                      value={1}
                      id="isCommissioned1"
                      onChange={() => {
                        setFieldValue("isCommissioned", 1);
                        setFieldValue("commissionedAt", "");
                      }}
                      checked={1 == values.isCommissioned}
                    />
                    <label
                      className="form-check-label"
                      htmlFor="isCommissioned1"
                    >
                      Commissioned
                    </label>
                  </div>
                  <div className="form-check-flex">
                    <Field
                      className="form-check-input"
                      type="radio"
                      name="isCommissioned"
                      value={2}
                      id="isCommissioned2"
                      onChange={() => {
                        setFieldValue("isCommissioned", 2);
                        setFieldValue("commissionedAt", "");
                      }}
                      checked={2 == values.isCommissioned}
                    />
                    <label
                      className="form-check-label"
                      htmlFor="isCommissioned2"
                    >
                      To Be Commissioned
                    </label>
                  </div>
                </div>
                <ErrorMessage
                  name="isCommissioned"
                  className="text-danger"
                  component="div"
                />
              </div>
              {values.isCommissioned && (
                <div className="col-md-6">
                  <label htmlFor="commissionedAt">Commissioned Date*</label>
                  <DatePicker
                    className="form-control custom-input w-100"
                    name="commissionedAt"
                    placeholderText="Select Date"
                    popperPlacement="bottom-start"
                    popperModifiers={{
                      flip: {
                        behavior: ["bottom"],
                      },
                      preventOverflow: {
                        enabled: false,
                      },
                    }}
                    // disabled={values.isCommissioned != 1}
                    selected={values.commissionedAt}
                    onChange={(e) => setFieldValue("commissionedAt", e)}
                    dateFormat={"dd-MMM-yyyy"}
                    onBlur={() => setFieldTouched("commissionedAt", true)}
                    minDate={values.isCommissioned == 2 && new Date()}
                    maxDate={values.isCommissioned == 1 && new Date()}
                    autoComplete="off"
                    showYearDropdown
                    showMonthDropdown
                    scrollableMonthYearDropdown
                  />
                  <ErrorMessage
                    className="text-danger"
                    name="commissionedAt"
                    component="div"
                  />
                </div>
              )}
            </Row>
            <Row className="mb-4">
              <div className="col-md-6">
                <div className="mb-3 fw-medium">
                  Generating Type{tab === "4" ? "" : "*"}
                </div>
                <div className="d-flex gap-3">
                  <div className="form-check-flex">
                    <Field
                      className="form-check-input"
                      type="radio"
                      name="generationType"
                      value={"RENEWABLE"}
                      id="generationType1"
                      checked={"RENEWABLE" == values.generationType}
                      onBlur={() => setFieldValue("energyTypeId", "")}
                    />
                    <label
                      className="form-check-label"
                      htmlFor="generationType1"
                    >
                      Renewable
                    </label>
                  </div>
                  <div className="form-check-flex">
                    <Field
                      className="form-check-input"
                      type="radio"
                      name="generationType"
                      value={"NON_RENEWABLE"}
                      id="generationType2"
                      checked={"NON_RENEWABLE" == values.generationType}
                    />
                    <label
                      className="form-check-label"
                      htmlFor="generationType2"
                    >
                      Non-Renewable
                    </label>
                  </div>
                </div>
                <ErrorMessage
                  name="generationType"
                  className="text-danger"
                  component="div"
                />
              </div>
              {values?.generationType && (
                <div className="col-md-6">
                  <label htmlFor="energyTypeId">
                    Energy Type{tab === "4" ? "" : "*"}
                  </label>
                  <Field
                    as="select"
                    name={"energyTypeId"}
                    className={`custom-input ${
                      values.energyTypeId ? "" : "custom-input-color"
                    } w-100`}
                    onChange={(e) => {
                      setFieldValue("energyTypeId", e.target.value);
                    }}
                  >
                    <option value="">Select Energy Type*</option>
                    {energyTypes
                      .filter((ite) => {
                        return values.generationType == "RENEWABLE"
                          ? ite.genType == "RENEWABLE"
                          : values.generationType == "NON_RENEWABLE"
                          ? ite.genType == "NON_RENEWABLE"
                          : "";
                      })
                      .map((item) => (
                        <option key={item?.id} value={item?.id}>
                          {item?.type}
                        </option>
                      ))}
                  </Field>
                  <ErrorMessage
                    name="energyTypeId"
                    className="text-danger"
                    component="div"
                  />
                </div>
              )}
            </Row>
            <Row className="justify-content-center align-items-center mb-4">
              <div className="col-md-6">
                <label htmlFor="plantSpecId">
                  Plant Specification{tab === "4" ? "" : "*"}
                </label>
                <Field
                  as="select"
                  disabled={tab == 4}
                  className={`custom-input ${
                    tab != 4 ? "" : "cursor-disabled"
                  } ${values.plantSpecId ? "" : "custom-input-color"} w-100`}
                  name={"plantSpecId"}
                  onChange={(e) => {
                    setFieldValue("plantSpecId", e.target.value);
                  }}
                >
                  <option value="">Select Plant Specification*</option>
                  {specificationTypes?.GENERATOR?.map((item) => (
                    <option key={item?.id} value={item?.id}>
                      {item?.name}
                    </option>
                  ))}
                </Field>
                <ErrorMessage
                  name="plantSpecId"
                  className="text-danger"
                  component="div"
                />
              </div>
              <div className="col-md-6">
                <label htmlFor="maximum-injection">
                  Maximum Injection Capacity (MW)*
                </label>
                <Field
                  className="form-control custom-input"
                  type="number"
                  onKeyDown={(e) => {
                    if (
                      e.key === "-" ||
                      e.key === "+" ||
                      e.key === "e" ||
                      e.key === "ArrowUp" ||
                      e.key === "ArrowDown"
                    ) {
                      e.preventDefault();
                    }
                  }}
                  onWheel={numberInputOnWheelPreventChange}
                  name="maxInjCap"
                />
                <ErrorMessage
                  name="maxInjCap"
                  className="text-danger"
                  component="div"
                />
              </div>
            </Row>
            <Row className="justify-content-center align-items-center mb-4">
              <div className="col-md-6">
                <label htmlFor="projectId">
                  Unique Project Identification Code
                </label>
                <Field
                  className="form-control custom-input"
                  type="text"
                  name="projectId"
                />
                <ErrorMessage
                  name="projectId"
                  className="text-danger"
                  component="div"
                />
              </div>
              <div className="col-md-6">
                <label htmlFor="installedCap">
                  Installed Capacity (In MW)*
                </label>
                <Field
                  className="form-control custom-input"
                  type="number"
                  onKeyDown={(e) => {
                    if (
                      e.key === "-" ||
                      e.key === "+" ||
                      e.key === "e" ||
                      e.key === "ArrowUp" ||
                      e.key === "ArrowDown"
                    ) {
                      e.preventDefault();
                    }
                  }}
                  onWheel={numberInputOnWheelPreventChange}
                  name="installedCap"
                />
                <ErrorMessage
                  name="installedCap"
                  className="text-danger"
                  component="div"
                />
              </div>
            </Row>
            <Row className=" justify-content-center align-items-center mb-4">
              <div className="col-md-6">
                <div className="mb-3 fw-medium">Subsidy Received</div>
                <div className="d-flex gap-3">
                  <div className="form-check-flex">
                    <Field
                      className="form-check-input"
                      type="radio"
                      name="isSubsidyRecvd"
                      value={1}
                      id="isSubsidyRecvd1"
                      checked={1 == values.isSubsidyRecvd}
                    />
                    <label
                      className="form-check-label"
                      htmlFor="isSubsidyRecvd1"
                    >
                      Yes
                    </label>
                  </div>
                  <div className="form-check-flex">
                    <Field
                      className="form-check-input"
                      type="radio"
                      name="isSubsidyRecvd"
                      value={2}
                      id="isSubsidyRecvd2"
                      checked={2 == values.isSubsidyRecvd}
                    />
                    <label
                      className="form-check-label"
                      htmlFor="isSubsidyRecvd2"
                    >
                      No
                    </label>
                  </div>
                </div>
                <ErrorMessage
                  name="isSubsidyRecvd"
                  className="text-danger"
                  component="div"
                />
              </div>
              <div className="col-md-6">
                <label htmlFor="subsidyType">Subsidy Type</label>
                <Field
                  className="form-control custom-input"
                  type="text"
                  name="subsidyType"
                />
                <ErrorMessage
                  name="subsidyType"
                  className="text-danger"
                  component="div"
                />
              </div>
            </Row>
            <Row className="mb-4">
              <div className="col-md-6">
                <div className="mb-3 fw-medium">ABT Metering Arrangement</div>
                <div className="d-flex gap-3">
                  <div className="form-check-flex">
                    <Field
                      className="form-check-input"
                      type="radio"
                      name="isAbtExist"
                      value={1}
                      id="isAbtExist1"
                      checked={1 == values.isAbtExist}
                    />
                    <label className="form-check-label" htmlFor="isAbtExist1">
                      Exists
                    </label>
                  </div>
                  <div className="form-check-flex">
                    <Field
                      className="form-check-input"
                      type="radio"
                      name="isAbtExist"
                      value={2}
                      id="isAbtExist2"
                      checked={2 == values.isAbtExist}
                    />
                    <label className="form-check-label" htmlFor="isAbtExist2">
                      To Be Arranged
                    </label>
                  </div>
                </div>
                <ErrorMessage
                  name="isAbtExist"
                  className="text-danger"
                  component="div"
                />
              </div>
              <div className="col-md-6">
                <label htmlFor="controlAreaId">Control Area</label>
                <Field
                  as="select"
                  className={`custom-input ${
                    values.controlAreaId ? "" : "custom-input-color"
                  } w-100`}
                  name={"controlAreaId"}
                  onChange={(e) => {
                    setFieldValue("controlAreaId", e.target.value);
                  }}
                >
                  <option value="">Select Control Area</option>
                  {controlAreaTypes.map((item) => (
                    <option key={item?.id} value={item?.id}>
                      {item?.type}
                    </option>
                  ))}
                </Field>
                <ErrorMessage
                  name="controlAreaId"
                  className="text-danger"
                  component="div"
                />
              </div>
            </Row>
            <Row className="justify-content-center align-items-center mb-4">
              <div className="col-md-6">
                <div className="mb-3 fw-medium">Point of Injection (POI)</div>
                <div className="d-flex gap-3">
                  {allPointDrawl.map((item, index) => (
                    <div className="form-check-flex">
                      <Field
                        className="form-check-input"
                        type="radio"
                        name="poiId"
                        value={item?.id}
                        id={`poiId${index + 1}`}
                        checked={item?.id == values.poiId}
                      />
                      <label
                        className="form-check-label"
                        htmlFor={`poiId${index + 1}`}
                      >
                        {item?.value}
                      </label>
                    </div>
                  ))}
                </div>
                <ErrorMessage
                  name="poiId"
                  className="text-danger"
                  component="div"
                />
              </div>
              <div className="col-md-6">
                <label htmlFor="poiLocation">Name of Location of POI</label>
                <Field
                  className="form-control custom-input"
                  type="text"
                  name="poiLocation"
                />
                <ErrorMessage
                  name="poiLocation"
                  className="text-danger"
                  component="div"
                />
              </div>
            </Row>
            {tab != 4 && (
              <>
                <Row className="justify-content-center align-items-center mb-4">
                  <div className="col-md-6">
                    <label htmlFor="regionId">Region*</label>
                    <Field
                      as="select"
                      className={`custom-input ${
                        values.regionId ? "" : "custom-input-color"
                      } w-100`}
                      name={"regionId"}
                      onChange={(e) => {
                        setFieldValue("regionId", e.target.value);
                        getAllStateByRegionId(e.target.value, dispatch);
                      }}
                    >
                      <option value="">Select Region*</option>
                      {regionTypes.map((item) => (
                        <option key={item?.id} value={item?.id}>
                          {item?.name}
                        </option>
                      ))}
                    </Field>
                    <ErrorMessage
                      name="regionId"
                      className="text-danger"
                      component="div"
                    />
                  </div>
                  <div className="col-md-6">
                    <label htmlFor="stateUtId">State*</label>
                    <Field
                      as="select"
                      className={`custom-input ${
                        values.stateUtId ? "" : "custom-input-color"
                      } w-100`}
                      name={"stateUtId"}
                      onChange={(e) => {
                        setFieldValue("stateUtId", e.target.value);
                        handleStateChange(e.target.value);
                      }}
                    >
                      <option value="">Select State*</option>
                      {stateOptions.map((item) => (
                        <option key={item?.id} value={item?.id}>
                          {item?.name}
                        </option>
                      ))}
                    </Field>
                    <ErrorMessage
                      name="stateUtId"
                      className="text-danger"
                      component="div"
                    />
                  </div>
                </Row>
                <Row>
                  <div className="col-md-6">
                    <label htmlFor="discomId">Name of Discom*</label>
                    <Field
                      as="select"
                      name={"discomId"}
                      className={`custom-input ${
                        values.discomId ? "" : "custom-input-color"
                      } w-100`}
                      onChange={(e) => {
                        setValues({
                          ...values,
                          filteredVoltageLevels: discomTypes?.find(
                            (item) => item.id == e.target.value
                          )?.voltageLevels,
                          discomId: e.target.value,
                          discomVoltageId: "",
                        });
                      }}
                    >
                      <option value="">Select Name of Discom*</option>
                      {discomOptions?.map((item) => (
                        <option key={item?.id} value={item?.id}>
                          {item?.acronym}
                        </option>
                      ))}
                    </Field>
                    <ErrorMessage
                      name="discomId"
                      className="text-danger"
                      component="div"
                    />
                  </div>
                  <div className="col-md-6">
                    <label htmlFor="discomVoltageId">Voltage level*</label>
                    <Field
                      as="select"
                      className={`custom-input ${
                        values.discomVoltageId ? "" : "custom-input-color"
                      } w-100`}
                      name="discomVoltageId"
                      onChange={(e) =>
                        setFieldValue("discomVoltageId", e.target.value)
                      }
                    >
                      <option value="">Select Voltage level*</option>
                      {(values.filteredVoltageLevels || [])?.map(
                        (voltageItem, index) => (
                          <option key={index} value={voltageItem}>
                            {voltageItem}
                          </option>
                        )
                      )}
                    </Field>
                    <ErrorMessage
                      name="discomVoltageId"
                      className="text-danger"
                      component="div"
                    />
                  </div>
                </Row>
              </>
            )}
            <hr
              style={{
                width: "100%",
                margin: "20px auto",
                marginBottom: "20px",
              }}
            />
            {tab == 1 || currentRoute === "/admin_comp_dashboard" ? (
              <Row className="mb-3">
                <div className="text-center mt-4 fw-bold">
                  <Button
                    className="btn btn-lg btn-signup py-3 px-4"
                    type="submit"
                  >
                    Submit & Sign up
                  </Button>
                </div>
              </Row>
            ) : (
              //Consumer details
              <>
                <h6>Consumer Details</h6>
                <Row className="justify-content-center align-items-center mb-4">
                  <div className="col-md-6">
                    <label htmlFor="maxCapDrawl">
                      Maximum Capacity of Drawal{tab === "4" ? "" : "*"}
                    </label>
                    <Field
                      className="form-control custom-input"
                      type="number"
                      onKeyDown={(e) => {
                        if (
                          e.key === "-" ||
                          e.key === "+" ||
                          e.key === "e" ||
                          e.key === "ArrowUp" ||
                          e.key === "ArrowDown"
                        ) {
                          e.preventDefault();
                        }
                      }}
                      onWheel={numberInputOnWheelPreventChange}
                      name="maxCapDrawl"
                    />
                    <ErrorMessage
                      name="maxCapDrawl"
                      className="text-danger"
                      component="div"
                    />
                  </div>
                  <div className="col-md-6">
                    <label htmlFor="podId">Point Of Drawal</label>
                    <Field
                      as="select"
                      className={`custom-input ${
                        values.podId ? "" : "custom-input-color"
                      } w-100`}
                      name="podId"
                      onChange={(e) => setFieldValue("podId", e.target.value)}
                    >
                      <option value=""> Select Point Of Drawal</option>
                      {allPointDrawl.map((item) => (
                        <option key={item?.id} value={item?.id}>
                          {item?.value}
                        </option>
                      ))}
                    </Field>
                  </div>
                </Row>
                <Row className=" mb-4">
                  <div className="col-md-6">
                    <label htmlFor="specId">Consumer Specification</label>
                    <Field
                      as="select"
                      disabled={tab == 4}
                      className={`custom-input ${
                        tab != 4 ? "" : "cursor-disabled"
                      } ${values.specId ? "" : "custom-input-color"} w-100`}
                      name="specId"
                      onChange={(e) => {
                        setFieldValue("specId", e.target.value);
                      }}
                    >
                      <option value="">Select Consumer Specification</option>
                      {specificationTypes?.CONSUMER?.map((item) => (
                        <option key={item?.id} value={item?.id}>
                          {item?.name}
                        </option>
                      ))}
                    </Field>
                  </div>
                  {tab != 4 && (
                    <div className="col-md-6">
                      <label htmlFor="discomRegionId">Region*</label>
                      <Field
                        as="select"
                        className={`custom-input ${
                          values.discomRegionId ? "" : "custom-input-color"
                        } w-100`}
                        name={"discomRegionId"}
                        onChange={(e) => {
                          setFieldValue("discomRegionId", e.target.value);
                          getAllStatesbyRegionIdforCon(
                            e.target.value,
                            dispatch
                          );
                        }}
                      >
                        <option value="">Select Region*</option>
                        {regionTypes.map((item) => (
                          <option key={item?.id} value={item?.id}>
                            {item?.name}
                          </option>
                        ))}
                      </Field>
                      <ErrorMessage
                        name="discomRegionId"
                        className="text-danger"
                        component="div"
                      />
                    </div>
                  )}
                </Row>
                {tab != 4 && (
                  <>
                    <Row className="justify-content-center align-items-center mb-4">
                      <div className="col-md-6">
                        <label htmlFor="discomStateUtId">State*</label>
                        <Field
                          as="select"
                          className={`custom-input ${
                            values.discomStateUtId ? "" : "custom-input-color"
                          } w-100`}
                          name={"discomStateUtId"}
                          onChange={(e) => {
                            setFieldValue("discomStateUtId", e.target.value);
                            handleStateChangeforCon(e.target.value);
                          }}
                        >
                          <option value="">Select State*</option>
                          {stateOptionsCon.map((item) => (
                            <option key={item?.id} value={item?.id}>
                              {item?.name}
                            </option>
                          ))}
                        </Field>
                        <ErrorMessage
                          name="discomStateUtId"
                          className="text-danger"
                          component="div"
                        />
                      </div>
                      <div className="col-md-6">
                        <label htmlFor="conDiscomId">Name of Discom*</label>
                        <Field
                          as="select"
                          name={"conDiscomId"}
                          className={`custom-input ${
                            values.conDiscomId ? "" : "custom-input-color"
                          } w-100`}
                          onChange={(e) => {
                            setValues({
                              ...values,
                              conFilteredVoltageLevels: discomTypes?.find(
                                (item) => item.id == e.target.value
                              )?.voltageLevels,
                              conDiscomId: e.target.value,
                              conDiscomVoltageId: "",
                            });
                          }}
                        >
                          <option value="">Select Name of Discom</option>
                          {discomOptionsCon?.map((item) => (
                            <option key={item?.id} value={item?.id}>
                              {item?.acronym}
                            </option>
                          ))}
                        </Field>
                        <ErrorMessage
                          name="conDiscomId"
                          className="text-danger"
                          component="div"
                        />
                      </div>
                    </Row>
                    <Row>
                      <div className="col-md-6">
                        <label htmlFor="conDiscomVoltageId">
                          Voltage level*
                        </label>
                        <Field
                          as="select"
                          className={`custom-input ${
                            values.conDiscomVoltageId
                              ? ""
                              : "custom-input-color"
                          } w-100`}
                          name="conDiscomVoltageId"
                          onChange={(e) =>
                            setFieldValue("conDiscomVoltageId", e.target.value)
                          }
                        >
                          <option value="">Select Voltage level</option>
                          {(values.conFilteredVoltageLevels || [])?.map(
                            (voltageItem, index) => (
                              <option key={index} value={voltageItem}>
                                {voltageItem}
                              </option>
                            )
                          )}
                        </Field>
                        <ErrorMessage
                          name="conDiscomVoltageId"
                          className="text-danger"
                          component="div"
                        />
                      </div>
                    </Row>
                    <hr
                      style={{
                        width: "100%",
                        margin: "20px auto",
                        marginBottom: "20px",
                      }}
                    />
                  </>
                )}
                <Row className="mb-3">
                  <div className="text-center mt-4 fw-bold">
                    <Button
                      className="btn btn-lg btn-signup py-3 px-4"
                      type="submit"
                    >
                      Submit & Sign up
                    </Button>
                  </div>
                </Row>
              </>
            )}
          </Form>
        );
      }}
    </Formik>
  );
};

export default React.memo(PlantDetails);
